const actions = {
  SET_STATE: 'gallery/SET_STATE',
  CREATE_GALLERY: 'gallery/CREATE_GALLERY',
  GET_GALLERY_LIST: 'gallery/GET_GALLERY_LIST',
  REMOVE_GALLERY: 'gallery/REMOVE_GALLERY',
  GET_SUB_GALLERY: 'gallery/GET_SUB_GALLERY',
  GET_GALLERY_BY_ID: 'gallery/GET_GALLERY_BY_ID',
  UPDATE_GALLERY: 'gallery/UPDATE_GALLERY',
  RESET_STATE: 'gallery/RESET_STATE',
}

export default actions
